import { ChangeLogSortField } from "@/graphql/codegen/graphql"

export type ChangeLogSortableAccessorKey = "category" | "createdOn" | "record" | "subcategory" | "userName"

export const accessorKeyToChangeLogSortField = new Map<ChangeLogSortableAccessorKey, ChangeLogSortField>([
  ["category", ChangeLogSortField.Category],
  ["createdOn", ChangeLogSortField.CreatedOn],
  ["record", ChangeLogSortField.Record],
  ["subcategory", ChangeLogSortField.Subcategory],
  ["userName", ChangeLogSortField.UserName],
])

export const changeLogSortFieldToAccessoryKey = new Map<ChangeLogSortField, ChangeLogSortableAccessorKey>([
  [ChangeLogSortField.Category, "category"],
  [ChangeLogSortField.CreatedOn, "createdOn"],

  [ChangeLogSortField.Record, "record"],
  [ChangeLogSortField.Subcategory, "subcategory"],
  [ChangeLogSortField.UserName, "userName"],
])
